import { useState } from 'react';
import { FriendsPicker } from '../components/FriendsPicker.js';
import { useApp } from '../store.js';
import { ShareButton } from './ShareButton.js';

/** Набор дружеского турнира: дуэль ждёт друга, кубок — друзей и старта создателем. */
export function Lobby() {
  const t = useApp((s) => s.tournament);
  const share = useApp((s) => s.share);
  const start = useApp((s) => s.startFriendly);
  const leave = useApp((s) => s.leaveTournament);
  const joining = useApp((s) => s.joining);
  const notice = useApp((s) => s.notice);
  const [copied, setCopied] = useState(false);
  if (!t) return null;
  const humans = t.players.filter((p) => !p.isBot).length;
  const duel = t.kind === 'DUEL';

  const copy = async () => {
    if (!t.inviteLink) return;
    try {
      await navigator.clipboard.writeText(t.inviteLink);
      setCopied(true);
    } catch {
      window.prompt('Ссылка-приглашение', t.inviteLink);
    }
  };

  return (
    <main className="screen lobby">
      <div className="search__spinner" aria-hidden="true">
        {duel ? '⚔️' : '👥'}
      </div>
      <h1 className="screen__title">{duel ? 'Вызов другу' : `Кубок с друзьями на ${t.size}`}</h1>
      <p className="screen__lead">
        {duel
          ? 'Отправьте ссылку — матч начнётся, как только друг её откроет'
          : t.isOwner
            ? 'Позовите друзей. Начать можно, когда придёт хотя бы один — свободные места займут боты'
            : 'Ждём, когда создатель начнёт кубок'}
      </p>
      <ol className="search__slots">
        {Array.from({ length: t.size }, (_, i) => {
          const p = t.players[i];
          return (
            <li
              key={i}
              className={`search__slot ${p ? 'search__slot--taken' : ''} ${p?.isYou ? 'search__slot--you' : ''}`}
            >
              {p ? (p.isYou ? 'Вы' : p.name) : '…'}
            </li>
          );
        })}
      </ol>
      {t.inviteLink && (
        <>
          <ShareButton
            label="📨 Пригласить в Telegram"
            onShare={() => share({ kind: 'invite', tournamentId: t.id })}
          />
          <button type="button" className="link" onClick={() => void copy()}>
            {copied ? 'Ссылка скопирована' : 'Скопировать ссылку'}
          </button>
        </>
      )}
      {t.inviteLink && <FriendsPicker tournament={t} />}
      {notice && (
        <p className="field__hint field__hint--error" role="alert">
          {notice}
        </p>
      )}
      {t.kind === 'FRIENDS' && t.isOwner && (
        <button
          type="button"
          className="play play--small"
          disabled={humans < 2 || joining}
          onClick={() => void start()}
        >
          {humans < 2 ? 'Начать — нужен хотя бы один друг' : `Начать (${humans} из ${t.size})`}
        </button>
      )}
      <button type="button" className="link" onClick={() => void leave()}>
        {t.isOwner ? 'Отменить' : 'Выйти'}
      </button>
      <p className="field__hint">Дружеский режим — без рейтинга и серебра</p>
    </main>
  );
}
